import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const PrivateRoute = ({ children }) => {
    const { user, loading } = useUser();

    if (loading) {
        return <div>Loading...</div>;  // Or a spinner component
    }

    return user ? children : <Navigate to="/" />;
};

export default PrivateRoute;